/*
  Pop-up salon tour page: place matching, schedule sorting, closest-stop search.
  The raw coordinate tables live in assets/lac-tour-geo.js and arrive as
  window.LAC_GEO. This file builds the lookup keys on top of them, so the
  matching rules can be corrected without touching 20KB of coordinates.

  Reads its two links from data attributes on .lac-tour:
    data-shop     where "shop online" goes
    data-consult  where "book a free online consultation" goes

  THE RESULT ALWAYS OFFERS ALL THREE ROUTES: tickets for the closest stop,
  shopping online, and a free online consultation. Lauren's call. Shopping
  online used to appear only when the nearest stop was more than 250 miles away,
  which quietly assumed a woman 40 miles from a pop-up would rather drive.
  Plenty would rather order tonight. Tickets stays the primary button and the
  far-away note still appears past 250 miles, so the recommendation is still
  clear without hiding the other two options.

  MATCH ORDER MATTERS, and every rule is a bug that actually happened:
    1. ZIP first, because a five digit number is unambiguous.
    2. Punctuation and commas are stripped from BOTH the visitor's text and the
       lookup keys before comparing. "Charleston, SC", "charleston sc" and
       "St. Louis" all have to reach their entry. Charleston was being sent to
       Spartanburg because "sc" matched the state, and St. Louis matched nothing
       at all because its key kept the full stop.
    3. Cities before states on an exact match, so "New York" is the city.
    4. Longest leading run before single state tokens, so "Fargo ND" is Fargo
       and not the middle of North Dakota.
    5. Single state tokens last, so "sc" alone still works but never steals a
       city name off the front of the string.

  What we show back is never the visitor's raw typing. Title casing
  "charleston sc" gives "Charleston Sc", which looks careless on a page a
  customer is reading, so every entry carries a proper display name.

  window.LAC_TOUR is exposed for testing: nearest(text) returns the row it would
  pick and the distance, without touching the DOM.
*/
(function () {
  var root = document.getElementById('lacStops');
  if (!root) return;

  function start() {
    var G = window.LAC_GEO;
    if (!G || !G.TOUR) return;

    function norm(s) {
      return String(s || '').toLowerCase()
        .replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function titleCase(s) {
      return String(s).replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
    }

    var ABBR = {};
    Object.keys(G.STATE).forEach(function (k) { if (k.length === 2) ABBR[k] = true; });

    /* "charleston, sc" -> "Charleston, SC";  "rochester mn" -> "Rochester, MN" */
    function pretty(key) {
      var t = titleCase(key.replace(/,/g, ' ').replace(/\s+/g, ' ').trim());
      var parts = t.split(' ');
      var last = parts[parts.length - 1].toLowerCase();
      if (parts.length > 1 && ABBR[last]) {
        return parts.slice(0, -1).join(' ') + ', ' + last.toUpperCase();
      }
      return t;
    }

    var TOURN = {}, CITYN = {}, STATEN = {}, LABEL = {};
    Object.keys(G.TOUR).forEach(function (k) {
      var flat = norm(k), name = pretty(k);
      TOURN[flat] = G.TOUR[k]; LABEL[flat] = name;
      var bare = flat.replace(/\s+[a-z]{2}$/, '');
      if (bare && bare !== flat && !TOURN[bare]) { TOURN[bare] = G.TOUR[k]; LABEL[bare] = name; }
    });
    Object.keys(G.CITY).forEach(function (k) {
      var f = norm(k);
      CITYN[f] = G.CITY[k];
      if (!LABEL[f]) LABEL[f] = pretty(k);
    });
    Object.keys(G.STATE).forEach(function (k) { STATEN[norm(k)] = G.STATE[k]; });

    function cityHit(key) {
      return { pt: TOURN[key] || CITYN[key], label: LABEL[key] || pretty(key) };
    }
    function stateHit(key) {
      var e = STATEN[key];
      return { pt: [e[0], e[1]], label: e[2], broad: true };
    }

    function resolve(raw) {
      var q = norm(raw);
      if (!q) return null;

      var zip = String(raw).match(/\b(\d{5})(?:-?\d{4})?\b/);
      if (zip && G.ZIP[zip[1].slice(0, 2)]) {
        return { pt: G.ZIP[zip[1].slice(0, 2)], label: zip[1], broad: true, zip: true };
      }

      if (TOURN[q] || CITYN[q]) return cityHit(q);
      if (STATEN[q]) return stateHit(q);

      var toks = q.split(' ');
      var i, j, sub;
      for (i = toks.length; i > 0; i--) {
        sub = toks.slice(0, i).join(' ');
        if (TOURN[sub] || CITYN[sub]) return cityHit(sub);
      }
      for (i = 0; i < toks.length; i++) {
        for (j = toks.length; j > i; j--) {
          sub = toks.slice(i, j).join(' ');
          if (TOURN[sub] || CITYN[sub]) return cityHit(sub);
        }
      }
      for (i = 0; i < toks.length; i++) {
        for (j = Math.min(i + 3, toks.length); j > i + 1; j--) {
          sub = toks.slice(i, j).join(' ');
          if (STATEN[sub]) return stateHit(sub);
        }
      }
      for (i = 0; i < toks.length; i++) {
        if (STATEN[toks[i]]) return stateHit(toks[i]);
      }
      return null;
    }

    G.resolve = resolve;
    G.TOURN = TOURN; G.CITYN = CITYN; G.STATEN = STATEN; G.norm = norm; G.pretty = pretty;

    var sec = document.querySelector('.lac-tour');
    var SHOP = (sec && sec.getAttribute('data-shop')) || '/collections/all';
    var CONSULT = (sec && sec.getAttribute('data-consult')) || '/pages/ask-our-experts';

    function miles(a, b) {
      var R = 3958.8, tr = Math.PI / 180;
      var dLat = (b[0] - a[0]) * tr, dLon = (b[1] - a[1]) * tr;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(a[0] * tr) * Math.cos(b[0] * tr) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return Math.round(R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s)));
    }

    /* ---- Schedule: sort, split past from upcoming, badge the next one. ---- */
    var rows = [].slice.call(root.querySelectorAll('.stop'));
    rows.sort(function (a, b) {
      return (+a.getAttribute('data-key')) - (+b.getAttribute('data-key'));
    });
    rows.forEach(function (r) { root.appendChild(r); });

    var d = new Date();
    var todayKey = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();

    var upcoming = [], past = [];
    rows.forEach(function (r) {
      if (+r.getAttribute('data-key') < todayKey) { r.classList.add('past'); past.push(r); }
      else { upcoming.push(r); }
    });

    if (upcoming.length) {
      upcoming[0].classList.add('next');
      var badge = document.createElement('span');
      badge.className = 'badge';
      badge.textContent = 'Next stop';
      var what = upcoming[0].querySelector('.what');
      what.insertBefore(badge, what.firstChild);
    }

    var pastBtn = document.getElementById('lacPastBtn');
    if (past.length && pastBtn) {
      pastBtn.hidden = false;
      pastBtn.textContent = 'Show ' + past.length + ' past stop' + (past.length === 1 ? '' : 's');
      pastBtn.addEventListener('click', function () {
        var on = past[0].classList.contains('on');
        past.forEach(function (r) { r.classList.toggle('on', !on); });
        pastBtn.textContent = (on ? 'Show ' : 'Hide ') + past.length + ' past stop' + (past.length === 1 ? '' : 's');
      });
    }

    /* ---- The search. ---------------------------------------------------- */
    var form = document.getElementById('lacForm');
    var input = document.getElementById('lacQ');
    var res = document.getElementById('lacRes');
    if (!form || !input || !res) return;

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function show(html) { res.innerHTML = html; res.hidden = false; }

    function nearest(text) {
      var found = resolve(text);
      if (!found || !upcoming.length) return null;
      var best = null, bestD = Infinity, i, city, pt, dist;
      for (i = 0; i < upcoming.length; i++) {
        city = norm(upcoming[i].getAttribute('data-city'));
        pt = TOURN[city];
        if (!pt) continue;
        dist = miles(found.pt, pt);
        if (dist < bestD) { bestD = dist; best = upcoming[i]; }
      }
      if (!best) return null;
      return { row: best, dist: bestD, found: found, city: best.getAttribute('data-city') };
    }
    window.LAC_TOUR = { nearest: nearest, resolve: resolve, upcoming: upcoming, rows: rows, miles: miles };

    function onlineButtons() {
      return '<a class="rbtn alt" href="' + esc(SHOP) + '">Shop Online</a>' +
             '<a class="rbtn alt" href="' + esc(CONSULT) + '">Free Online Consultation</a>';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      rows.forEach(function (r) { r.classList.remove('hit'); });

      var found = resolve(input.value);
      if (!found) {
        show('<p class="rlab">No match</p><p class="miss">We could not place "' + esc(input.value) +
          '". Try your ZIP code, your state, or the nearest big city, for example 44114, Ohio or Cleveland. ' +
          'You can also shop online with free shade matching, or book a free online consultation and a ' +
          'licensed stylist will match your color and length from home.</p>' +
          '<div class="racts">' + onlineButtons() + '</div>');
        return;
      }
      if (!upcoming.length) {
        show('<p class="rlab">Next tour</p><p class="miss">Our next set of dates is being announced. ' +
          'In the meantime you can shop online with free shade matching by a licensed stylist.</p>' +
          '<div class="racts">' + onlineButtons() + '</div>');
        return;
      }

      var hit = nearest(input.value);
      if (!hit) {
        show('<p class="rlab">Next tour</p><p class="miss">We could not work out the closest stop. ' +
          'The full schedule is below, or shop online with free shade matching.</p>' +
          '<div class="racts">' + onlineButtons() + '</div>');
        return;
      }

      var best = hit.row, bestD = hit.dist, name = hit.city;
      var url = best.getAttribute('data-url');
      var date = best.querySelector('.dt') ? best.querySelector('.dt').textContent : '';
      var addr = best.querySelector('.ad') ? best.querySelector('.ad').textContent : '';
      var hours = Math.max(1, Math.round(bestD / 55));
      var hourTxt = hours + ' hour' + (hours === 1 ? '' : 's');

      var from = found.zip ? 'ZIP ' + esc(found.label)
               : found.broad ? 'the middle of ' + esc(found.label)
               : esc(found.label);
      var howfar = bestD < 12
        ? 'That one is in ' + esc(found.label) + '.'
        : (found.broad
            ? 'About ' + bestD + ' miles from ' + from + '.'
            : 'About ' + bestD + ' miles from ' + from + ', roughly ' + hourTxt + ' by car.');

      var note;
      if (bestD > 250) {
        note = '<p class="far">That is around ' + hourTxt + ' of driving. If it is too far, you can shop ' +
          'online with free shade matching by a licensed stylist, or book a free online consultation and ' +
          'we will fit you from home.</p>';
      } else {
        note = '<p class="far">Prefer not to travel? You can shop online with free shade matching, or book ' +
          'a free online consultation and a licensed stylist will fit you from home.</p>';
      }

      show(
        '<p class="rlab">Your closest pop-up salon</p>' +
        '<p class="rcity">' + esc(name) + '</p>' +
        '<p class="rmeta">' + esc(date) + '. ' + howfar + '</p>' +
        (addr ? '<p class="rad">' + esc(addr) + '</p>' : '') +
        note +
        '<div class="racts">' +
        '<a class="rbtn" href="' + esc(url) + '">Get tickets for ' + esc(name) + '</a>' +
        onlineButtons() +
        '</div>'
      );

      best.classList.add('hit');
      res.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (window.LAC_GEO) { start(); }
  else { window.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();
